import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router-dom';
import useHeaderSticky from '../../hooks/useHeaderSticky';
import TopBar from '../topbar/Topbar';
import MainMenu from './MainMenu';
import MiniSliderNews from './MiniNews';
import OffCanvasMenu from './OffcanvasMenu';
import './style.scss';
import { useFetchSloganData } from '../../hooks/useFetchSloganData';

const Header1 = (props) => {
  const [isSticky] = useHeaderSticky();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const { slogan, loading } = useFetchSloganData();

  const getTranslatedTitle = (sloganData) => {
    if (!sloganData || !sloganData.translations) return null;
    return (
      sloganData.translations[lang]?.title || sloganData.translations.tk?.title
    );
  };

  const translatedTitle = getTranslatedTitle(slogan);

  const displayTitle = loading ? '' : translatedTitle;

  const hasValidImage = !loading && slogan?.image;

  return (
    <>
      <header
        className={`site-header header-default header-sticky ${
          isSticky ? 'header-sticky' : ''
        } ${props.className || ''}`}
      >
        <TopBar className="" containerSize="container" />
        <div className={`header-wrapper  ${isSticky ? 'min-navbar' : ''}`}>
          <Container>
            <div className="site-year-logo logo-sm">
              {/* <div className="logo-text text-end">{t('year_logo')}</div> */}
              <NavLink className="logo-link" to="/">
                {hasValidImage && (
                  <img
                    alt={displayTitle || ''}
                    src={slogan.image}
                    width={56}
                    height={56}
                    className="tw-size-14"
                  />
                )}
              </NavLink>
            </div>
            <div className="header-inner tw-flex tw-flex-row tw-justify-between tw-items-center">
              <div className="site-logo">
                <NavLink className="" to="/">
                  <img
                    alt=""
                    src="/images/logo.png"
                    className="tw-size-14"
                    width={56}
                    height={56}
                  />
                  <div className="logo-text">
                    <span className="text-lighter">{t('iicimet')}</span>
                    <br className="d-xs-none" />
                    <div>{t('iicimet_short')}</div>
                  </div>
                </NavLink>
              </div>

              <div className="mobile-menu-btn lg:tw-hidden">
                <OffCanvasMenu position="end" />
              </div>
              <div className="site__logos">
                <div className="site-year-logo logo-lg">
                  <div className="logo-text text-lighter tw-text-balance tw-text-right tw-max-w-[40rem]">
                    {displayTitle}
                  </div>
                  <NavLink className="logo-link tw-flex-shrink-0" to="/">
                    {hasValidImage && (
                      <img alt={displayTitle || ''} src={slogan.image} />
                    )}
                  </NavLink>
                </div>
                {/* <NavLink
                  to="https://neutrality.gov.tm/"
                  target="_blank"
                  className="site__neutrality_logo"
                >
                  <img src="/images/neutrality.jpg" alt="" />
                  <p>neutrality.gov.tm</p>
                </NavLink> */}
              </div>
            </div>
          </Container>
        </div>
        <div className="header-wrapper categories-bar">
          <Container className="">
            <div className="header-inner ">
              <div className="main-menu tw-w-full tw-hidden lg:tw-block">
                <MainMenu />
              </div>
            </div>
          </Container>
        </div>
        <div className={`mini-slider-news`}>
          <MiniSliderNews />
        </div>
      </header>
      <Outlet />
    </>
  );
};

export default Header1;
